import React, { useState, useEffect, useCallback } from "react";
import { styled } from "@mui/material/styles";
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { uiInfoService } from "../../../services";

const tableConfig = {
  initial_table: [
    { key: "mtef", label: "MTEF (12)" },
    { key: "proposed", label: "Proposed Budget (13)" },
    { key: "approved", label: "Approved Budget (21)" },
    { key: "citizen", label: "Citizens' Budget (15)" },
    { key: "quarterly", label: "Quarterly BIR (16)" },
    { key: "procurement", label: "e-Procurement Portal (11)" },
    { key: "website", label: "State Website with Fiscal Data Repository (12)" },
  ],
  second_table: [
    { key: "mtef", label: "MTEF (12)" },
    { key: "approved", label: "Approved Budget (21)" },
    { key: "citizen", label: "Citizens' Budget (15)" },
    { key: "quarterly", label: "Quarterly BIR (16)" },
    { key: "audit", label: "Audit Report (18)" },
    { key: "ag_report", label: "Accountant General’s Report (15)" },
    { key: "procurement", label: "e-Procurement Portal (11)" },
    { key: "website", label: "State Website with Fiscal Data (12)" },
  ],
  second_2_table: [
    { key: "mtef", label: "MTEF (12)" },
    { key: "approved", label: "Approved Budget (21)" },
    { key: "citizen", label: "Citizens' Budget (15)" },
    { key: "quarterly", label: "Quarterly BIR (16)" },
    { key: "ag_report", label: "Accountant General’s Report (15)" },
    { key: "procurement", label: "e-Procurement Portal (11)" },
    { key: "website", label: "State Website with Fiscal Data (12)" },
  ],
  third_table: [
    { key: "mtef", label: "MTEF (12)" },
    { key: "approved", label: "Approved Budget (21)" },
    { key: "quarterly", label: "Quarterly BIR (16)" },
    { key: "audit", label: "Audit Report (18)" },
    { key: "ag_report", label: "Accountant General’s Report (15)" },
    { key: "procurement", label: "e-Procurement Portal (11)" },
    { key: "website", label: "State Website with Fiscal Data (12)" },
  ],
  fourth_table: [
    { key: "proposed", label: "Proposed Budget (13)" },
    { key: "approved", label: "Approved Budget (21)" },
    { key: "quarterly", label: "Quarterly BIR (16)" },
    { key: "procurement", label: "e-Procurement Portal (11)" },
    { key: "website", label: "State Website with Fiscal Data (12)" },
  ],
  fifth_table: [
    { key: "citizen", label: "Citizens' Budget (15)" },
    { key: "quarterly", label: "Quarterly BIR (16)" },
    { key: "procurement", label: "e-Procurement Portal (11)" },
    { key: "website", label: "State Website with Fiscal Data (12)" },
  ],
  sixth_table: [
    { key: "quarterly", label: "Quarterly BIR (16)" },
    { key: "ag_report", label: "Accountant General’s Report (15)" },
    { key: "procurement", label: "e-Procurement Portal (11)" },
    { key: "website", label: "State Website with Fiscal Data (12)" },
  ],
  seventh_table: [
    { key: "quarterly", label: "Quarterly BIR (16)" },
    { key: "mtef", label: "MTEF (12)" },
    { key: "procurement", label: "e-Procurement Portal (11)" },
    { key: "website", label: "State Website with Fiscal Data (12)" },
  ],
  default: [
    { key: "mtef", label: "MTEF (12)" },
    { key: "proposed", label: "Proposed Budget (13)" },
    { key: "approved", label: "Approved Budget (21)" },
    { key: "citizen", label: "Citizens' Budget (15)" },
    { key: "quarterly", label: "Quarterly BIR (16)" },
    { key: "audit", label: "Audit Report (18)" },
    { key: "ag_report", label: "Accountant General’s Report (15)" },
    { key: "procurement", label: "e-Procurement Portal (11)" },
    { key: "website", label: "State Website with Fiscal Data Repository (12)" },
  ],
};

const LatestTable = ({ selectedPeriod }) => {
  const [sortedStates, setSortedStates] = useState([]);
  const [isCustomTable, setIsCustomTable] = useState("default");

  const fetchLeagueData = useCallback(
    async (period_id) => {
      try {
        if (period_id) {
          const data = await uiInfoService.getPeriodByID(period_id);
          refreshSortedStates(data.period_id);
          if ([1, 2, 5, 9].includes(period_id)) {
            setIsCustomTable("initial_table");
          } else if ([6].includes(period_id)) {
            setIsCustomTable("second_table");
          } else if ([10].includes(period_id)) {
            setIsCustomTable("second_2_table");
          } else if ([7, 8].includes(period_id)) {
            setIsCustomTable("third_table");
          } else if ([13, 17, 21].includes(period_id)) {
            setIsCustomTable("fourth_table");
          } else if ([14, 18, 22].includes(period_id)) {
            setIsCustomTable("fifth_table");
          } else if ([11, 15, 19, 23].includes(period_id)) {
            setIsCustomTable("sixth_table");
          } else if ([12, 16, 20, 24].includes(period_id)) {
            setIsCustomTable("seventh_table");
          } else {
            setIsCustomTable("default");
          }
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    [uiInfoService, sortedStates],
  );

  useEffect(() => {
    fetchLeagueData(selectedPeriod);
  }, [selectedPeriod, fetchLeagueData]);

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#1C4E63",
      color: theme.palette.common.white,
      fontWeight: 700,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 24,
      fontWeight: 700,
    },
  }));

  const sumLastColumn = (state) => {
    const columns = tableConfig[isCustomTable];
    let divisor;

    switch (isCustomTable) {
      case "initial_table":
        divisor = 100;
        break;
      case "second_table":
        divisor = 120;
        break;
      case "second_2_table":
        divisor = 102;
        break;
      case "third_table":
        divisor = 105;
        break;
      case "fourth_table":
        divisor = 73;
        break;
      case "fifth_table":
        divisor = 54;
        break;
      case "sixth_table":
        divisor = 54;
        break;
      case "seventh_table":
        divisor = 51;
        break;
      default:
        divisor = 133;
        break;
    }

    return (
      (columns.reduce(
        (sum, column) =>
          sum +
          (typeof state.data[column.key] === "number"
            ? state.data[column.key]
            : 0),
        0,
      ) /
        divisor) *
      100
    ).toFixed();
  };

  const refreshSortedStates = (data) => {
    if (data && data.states) {
      const newSortedStates = data.states
        .slice()
        .sort((a, b) => sumLastColumn(b) - sumLastColumn(a));
      setSortedStates(newSortedStates);
    } else {
      setSortedStates([]);
    }
  };

  const getRowTextColor = (index) => {
    if (index < 9) {
      return "#16FF00";
    } else if (index >= sortedStates.length - 3) {
      return "#fc2d2d";
    } else {
      return "#FDFF00";
    }
  };

  const getLatestQuarter = () => {
    switch (selectedPeriod) {
      case 4:
        return "Q4 2023";
      case 5:
        return "Q1 2024";
      case 6:
        return "Q2 2024";
      case 7:
        return "Q3 2024";
      case 8:
        return "Q4 2024";
      case 9:
        return "Q1 2025";
      case 10:
        return "Q2 2025";
      case 11:
        return "Q3 2025";
      case 12:
        return "Q4 2025";
      case 13:
        return "Q1 2026";
      case 14:
        return "Q2 2026";
      case 15:
        return "Q3 2026";
      case 16:
        return "Q4 2026";
      default:
        return "";
    }
  };

  const columns = tableConfig[isCustomTable] || tableConfig.default;

  return (
    <Box marginTop={{ xs: "15%", sm: "2%" }}>
      <Typography
        variant="h3"
        color={"#049593"}
        align={"left"}
        fontWeight={700}
        gutterBottom
        marginBottom={{ xs: "15%", sm: "2%" }}
      >
        States Fiscal Transparency League Table
      </Typography>
      <Box marginBottom={{ xs: "10%", sm: "2%" }}>
        <Box
          width={{ xs: "50%", sm: "25%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
        >
          <Typography
            variant={"h6"}
            sx={{ marginBottom: 1 }}
            fontWeight={700}
            color={"#1C4E63"}
          >
            <strong>Latest Quarter:</strong> {getLatestQuarter()}
          </Typography>
        </Box>
      </Box>
      <TableContainer component={Paper}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              <StyledTableCell align="left">S/N</StyledTableCell>
              <StyledTableCell align="left">Name of States</StyledTableCell>
              {columns.map((column) => (
                <StyledTableCell key={column.key} align="center">
                  {column.label}
                </StyledTableCell>
              ))}
              <StyledTableCell align="center">Score (%)</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedStates.length === 0 ? (
              <TableRow>
                <StyledTableCell align="left" colSpan={columns.length + 2}>
                  <Typography
                    variant="h4"
                    color={"#049593"}
                    align="center"
                    fontWeight={700}
                  >
                    No League Score
                  </Typography>
                </StyledTableCell>
              </TableRow>
            ) : (
              sortedStates.map((state, index) => (
                <TableRow key={index} style={{ backgroundColor: "#1C4E63" }}>
                  <TableCell
                    style={{
                      color: getRowTextColor(index),
                      fontWeight: 600,
                      fontSize: 14,
                      textAlign: "center",
                    }}
                  >
                    {index + 1}
                  </TableCell>
                  <TableCell
                    align="left"
                    style={{
                      color: getRowTextColor(index),
                      fontWeight: 600,
                      fontSize: 14,
                    }}
                  >
                    {state.state_name}
                  </TableCell>
                  {columns.map((column) => (
                    <TableCell
                      key={column.key}
                      style={{
                        color: getRowTextColor(index),
                        fontWeight: 600,
                        fontSize: 14,
                        textAlign: "center",
                      }}
                    >
                      {state.data[column.key]}
                    </TableCell>
                  ))}
                  <TableCell
                    style={{
                      color: getRowTextColor(index),
                      fontWeight: 600,
                      fontSize: 14,
                      textAlign: "center",
                    }}
                  >
                    {sumLastColumn(state)}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default LatestTable;
